import React from "react";
import { motion } from "framer-motion";

const Tantangan = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full gap-5 md:gap-7 px-5 md:px-10 lg:px-16 overflow-hidden">
      <motion.div
        className="text-cust-blue font-bold text-2xl md:text-3xl text-center md:text-left w-full"
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          duration: 1,
          ease: "easeInOut",
          delay: 1,
        }}
        viewport={{ once: true }}
      >
        Tantangan Pemberdayaan <span className="text-cust-orange">UMKM</span>
      </motion.div>
      <motion.ol
        className="list-decimal ml-10 flex flex-col gap-2 w-full font-bold text-lg md:text-xl"
        initial={{
          opacity: 0,
          x: 100,
        }}
        whileInView={{
          opacity: 1,
          x: 0,
        }}
        transition={{
          duration: 1,
          ease: "easeInOut",
          delay: 1,
        }}
        viewport={{ once: true }}
      >
        <motion.li
          initial={{
            opacity: 0,
            x: 100,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 2,
          }}
          viewport={{ once: true }}
        >
          Mayoritas UMKM masih berskala Usaha Mikro,{" "}
          <span className="font-normal">
            sehingga belum mampu menyediakan lapangan kerja yang layak.
          </span>
        </motion.li>
        <motion.li
          initial={{
            opacity: 0,
            x: 100,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 2.5,
          }}
          viewport={{ once: true }}
        >
          Kurangnya penerapan standar, sertifikasi, teknologi dan inovasi{" "}
          <span className="font-normal">pada wirausaha dan UMKM.</span>
        </motion.li>
        <motion.li
          initial={{
            opacity: 0,
            x: 100,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 3,
          }}
          viewport={{ once: true }}
        >
          Rendahnya kemitraan UMKM{" "}
          <span className="font-normal">dalam rantai nilai industri.</span>
        </motion.li>
        <motion.li
          initial={{
            opacity: 0,
            x: 100,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 3.5,
          }}
          viewport={{ once: true }}
        >
          Belum optimalnya ekosistem usaha{" "}
          <span className="font-normal">
            dalam mendukung pengembangan kewirausahaan dan UMKM.
          </span>
        </motion.li>
      </motion.ol>
    </div>
  );
};

export default Tantangan;
